/* eslint-disable tsdoc/syntax */
import { SVGProps } from "react";
export const NoData3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 120 80"
    width="1em"
    height="1em"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      stroke="#E67068"
      strokeLinecap="round"
      strokeWidth={1.793}
      d="m63.572 6.479-.415 10.017"
    />
    <g stroke="#E67068" strokeLinecap="round" strokeWidth={1.345}>
      <path d="m114.233 48.706.515 4.265M116.695 50.572l-4.409.533" />
    </g>
    <path
      stroke="#E67068"
      strokeLinecap="round"
      strokeWidth={1.793}
      d="m72.465 14.43-2.635 1.922M53.012 11.059l3.652 5.062"
    />
    <path
      stroke="#C9D0D6"
      strokeWidth={0.897}
      d="M101.281 10.15c.983-.119 1.847.556 1.958 1.471.111.916-.569 1.777-1.551 1.895-.983.119-1.847-.555-1.958-1.47-.11-.916.568-1.777 1.551-1.896ZM30.287 10.15c.985-.118 1.851.558 1.962 1.476.111.918-.57 1.781-1.555 1.9-.985.12-1.852-.556-1.963-1.475-.111-.918.57-1.781 1.556-1.9Z"
    />
    <path
      stroke="#E67068"
      strokeWidth={1.345}
      d="M5.048 30.463c1.275-.154 2.391.72 2.534 1.9.143 1.182-.733 2.298-2.009 2.452-1.275.154-2.39-.721-2.533-1.902-.143-1.182.733-2.296 2.008-2.45Z"
    />
    <rect width={78} height={17} x={21.028} y={83.439} fill="#F6F7F7" rx={5} />
    <rect width={78} height={51} x={21.028} y={27.439} fill="#DDE1E5" rx={5} />
    <path
      fill="#fff"
      d="m57.34 58.483-.504-17.243h4.932l-.54 17.243H57.34Zm2.052 8.209c-.864 0-1.572-.264-2.124-.792a2.6 2.6 0 0 1-.792-1.909c0-.767.264-1.416.792-1.944.552-.527 1.26-.791 2.124-.791.816 0 1.488.264 2.016.791.552.529.828 1.177.828 1.945 0 .744-.276 1.38-.828 1.908-.528.527-1.2.791-2.016.791Z"
    />
  </svg>
);
